<ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Car">
    <h3>Groene Kaart auto</h3>
    <p>
        Hier vindt u uw Groene Kaart (uw internationaal verzekeringsbewijs) van InShared. Niet verplicht in Nederland,
        maar toch handig om te hebben. Hij is 1 jaar geldig vanaf nu.
    </p>
</ng-container>

<ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Moped">
    <h3>Groene Kaart brommer</h3>
    <p>
        Vroeger kon u met de Groene Kaart aantonen dat uw brommer verzekerd was. Tegenwoordig wordt dit afgeleid uit uw
        kenteken. Buiten Nederland heeft u de Groene Kaart soms nog wel nodig als verzekeringsbewijs, dus het is altijd
        handig om er een bij u te hebben als u over de grens gaat.
    </p>
</ng-container>

<ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Motorcycle">
    <h3>Groene Kaart motor</h3>
    <p>
        Vroeger kon u met de Groene Kaart aantonen dat uw motor verzekerd was. Tegenwoordig wordt dit afgeleid uit uw
        kenteken. Buiten Nederland heeft u de Groene Kaart soms nog wel nodig als verzekeringsbewijs, dus het is altijd
        handig om er een bij u te hebben als u over de grens gaat.
    </p>
</ng-container>

<ng-container *ngIf="purchasedProduct?.productId === productIdEnum.Caravan">
    <h3>Groene Kaart caravan</h3>
    <p>
        Vroeger kon u met de Groene Kaart aantonen dat uw caravan verzekerd was. Tegenwoordig wordt dit afgeleid uit uw
        kenteken. Buiten Nederland heeft u de Groene Kaart soms nog wel nodig als verzekeringsbewijs, dus het is altijd
        handig om er een bij u te hebben als u over de grens gaat.
    </p>
</ng-container>

<wuc-alert text="Uw Groene Kaart is gedownload" icon="download-international-insurance-card" type="neutral"
           *ngIf="downloadSuccess"></wuc-alert>

<wuc-alert text="Uw Groene Kaart is naar u gemaild" icon="mail" type="neutral"
           *ngIf="emailSuccess"></wuc-alert>

<wuc-balloon *ngIf="errors.length > 0" backgroundStyle="secondary" arrowPosition="topLeft" padding="medium" [hasCloseIcon]="false"
             [isFullWidth]="true">
    <wuc-list icon="cross">
        <ng-container *ngFor="let error of errors">
            <wuc-list-item>{{ error }}</wuc-list-item>
        </ng-container>
    </wuc-list>
</wuc-balloon>

<wuc-alert *ngIf="isDisabled" type="primary" icon="privacy" [text]="warningText"></wuc-alert>

<ins-insurance-imic-button-download
    class="insurance-imic-buttons__action-button"
    [purchasedProduct]="purchasedProduct"
    (loadSuccess)="loadDownloadSuccess($event)"
    (loadError)="loadError($event)"
></ins-insurance-imic-button-download>
<ins-insurance-imic-button-email
    class="insurance-imic-buttons__action-button"
    [purchasedProduct]="purchasedProduct"
    (loadSuccess)="loadEmailSuccess($event)"
    (loadError)="loadError($event)"
></ins-insurance-imic-button-email>
